import { render, staticRenderFns } from "./JLzh.vue?vue&type=template&id=e6f4819c&scoped=true"
import script from "./JLzh.vue?vue&type=script&lang=js"
export * from "./JLzh.vue?vue&type=script&lang=js"
import style0 from "./JLzh.vue?vue&type=style&index=0&id=e6f4819c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6f4819c",
  null
  
)

export default component.exports